// src/admin/ShareTab-report-status-react.js
import React from "react";
import { Button, Grid, Card, Table, Page } from "tabler-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShareTabDownloadPopup from "./DownloadPopup";
import { connect } from "react-redux";
import authActions from "../redux/auth/action";

const TIMEZONE = "Asia/Kolkata";

class ShareTabReportData extends React.Component {
  state = {
    jobId: null,
    latestJobs: [],
    latestSchedules: [],
  };

  componentDidMount() {
    if (this.props.user) {
      this.fetchLatestJobs();
      this.fetchLatestSchedules();
    }
  }

  fetchLatestJobs = () => {
    fetch(`${process.env.REACT_APP_apiUrl}notification/jobStatus`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data.jobs)) {
          this.setState({ latestJobs: data.jobs });
        }
      })
      .catch(console.error);
  };

  fetchLatestSchedules = () => {
    fetch(`${process.env.REACT_APP_apiUrl}notification/listSchedules`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data.schedules)) {
          this.setState({ latestSchedules: data.schedules });
        }
      })
      .catch(console.error);
  };

  startExportJob = (
    { startDate, endDate, notificationType, selectedOptionUserType },
    scheduleConfig
  ) => {
    const templateLabel =
      (selectedOptionUserType && selectedOptionUserType.label) || "";

    if (scheduleConfig.mode === "scheduled") {
      // build flat payload for Mongo schema
      const scopeType = scheduleConfig.scope.type;
      const isRelative = scopeType.startsWith("last_n_");

      const payload = {
        emails: scheduleConfig.emails,
        notificationType,
        template: templateLabel,
        timezone: TIMEZONE,

        scopeMode: isRelative ? "relative" : "fixed",
        scopeValue: isRelative ? scheduleConfig.scope.n : undefined,
        scopeUnit: isRelative ? scopeType.replace("last_n_", "") : undefined,

        freqValue: scheduleConfig.frequency.interval,
        freqUnit: scheduleConfig.frequency.unit,
      };

      if (!isRelative) {
        // inject fixed-range dates
        payload.from = scheduleConfig.dateRange.from;
        payload.to = scheduleConfig.dateRange.to;
      }

      fetch(`${process.env.REACT_APP_apiUrl}notification/scheduleReport`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.scheduleId) {
            toast.success("Report schedule created.");
            this.fetchLatestSchedules();
          } else {
            toast.error("Failed to create schedule.");
          }
        })
        .catch(() => toast.error("Network error creating schedule"));
    } else {
      // one-time export remains unchanged
      const start = startDate.toISOString().slice(0, 10);
      const end = endDate.toISOString().slice(0, 10);
      let url =
        `${process.env.REACT_APP_apiUrl}notification/downloadNotification` +
        `?startdate=${start}&enddate=${end}&timezone=${TIMEZONE}`;

      if (notificationType) url += `&type=${notificationType}`;
      if (templateLabel) url += `&template=${templateLabel}`;

      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          if (data.jobId) {
            toast.success("Export job requested.");
            this.setState({ jobId: data.jobId });
            this.fetchLatestJobs();
          } else {
            toast.error("Failed to request export job.");
          }
        })
        .catch(() => toast.error("Network error requesting export"));
    }
  };

  // ── new method ─────────────────────────────────────────────────────────────
  deleteSchedule = (scheduleId) => {
    const url = `${process.env.REACT_APP_apiUrl}notification/schedule/${scheduleId}`;
    fetch(url, { method: "DELETE" })
      .then((res) => {
        if (res.ok) {
          toast.success("Schedule deleted.");
          this.fetchLatestSchedules();
        } else {
          toast.error("Failed to delete schedule.");
        }
      })
      .catch(() => toast.error("Network error deleting schedule"));
  };
  // ─

  render() {
    const { latestJobs, latestSchedules, jobId } = this.state;
    const { openInfoPopup, onChange } = this.props;
    console.log(latestSchedules, "latestSchedules");

    return (
      <Page.Content>
        <ToastContainer autoClose={5000} position="bottom-right" />

        <Grid.Row>
          <Grid.Col lg={12}>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <Card.Title>Export Report</Card.Title>
                <Button color="secondary" onClick={this.fetchLatestJobs}>
                  Refresh
                </Button>
              </Card.Header>
              <Card.Body>
                <h5>One-Time Jobs</h5>
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.ColHeader>Job ID</Table.ColHeader>
                      <Table.ColHeader>Status</Table.ColHeader>
                      <Table.ColHeader>Created At</Table.ColHeader>
                      <Table.ColHeader>Action</Table.ColHeader>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {latestJobs.map((job, i) => (
                      <Table.Row key={i}>
                        <Table.Col>{job.jobId}</Table.Col>
                        <Table.Col>{job.status}</Table.Col>
                        <Table.Col>
                          {new Date(job.createdAt).toLocaleString()}
                        </Table.Col>
                        <Table.Col>
                          {job.status === "completed" && (
                            <Button
                              color="success"
                              onClick={() =>
                                window.open(
                                  `${process.env.REACT_APP_apiUrl}notification/download/${job.jobId}/file`,
                                  "_blank"
                                )
                              }
                            >
                              Download
                            </Button>
                          )}
                        </Table.Col>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>

                <h5 className="mt-4">Recurring Schedules</h5>
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.ColHeader>Schedule ID</Table.ColHeader>
                      <Table.ColHeader>Emails</Table.ColHeader>
                      <Table.ColHeader>Scope / Frequency</Table.ColHeader>
                      <Table.ColHeader>Created At</Table.ColHeader>
                      <Table.ColHeader>Status</Table.ColHeader>
                      <Table.ColHeader>Action</Table.ColHeader>{" "}
                      {/* ← new header */}
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {latestSchedules.map((s, i) => (
                      <Table.Row key={i}>
                        <Table.Col>{s._id}</Table.Col>
                        <Table.Col>
                          {(Array.isArray(s.emails)
                            ? s.emails.join(", ")
                            : "") || "—"}
                        </Table.Col>
                        <Table.Col>
                          {s.scopeMode === "fixed"
                            ? `${s.from} → ${s.to}`
                            : `Last ${s.scopeValue} ${s.scopeUnit}`}
                          <br />
                          {`Every ${s.freqValue} ${s.freqUnit}`}
                        </Table.Col>
                        <Table.Col>
                          {new Date(s.createdAt).toLocaleString()}
                        </Table.Col>
                        <Table.Col>
                          {s.isActive ? "Active" : "Paused"}
                        </Table.Col>
                        <Table.Col>
                          {" "}
                          {/* ← new cell */}
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => this.deleteSchedule(s._id)}
                          >
                            Delete
                          </Button>
                        </Table.Col>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>

        <ShareTabDownloadPopup
          openInfoPopup={openInfoPopup.open}
          onChange={onChange}
          onExportJobStart={this.startExportJob}
        />
      </Page.Content>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(authActions.authLogout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareTabReportData);
